/**
 * Log levels for the logger
 */
export var LogLevel;
(function (LogLevel) {
    LogLevel["ERROR"] = "ERROR";
    LogLevel["WARN"] = "WARN";
    LogLevel["INFO"] = "INFO";
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["TRACE"] = "TRACE";
})(LogLevel || (LogLevel = {}));
/**
 * Log categories for organizing logs
 */
export var LogCategory;
(function (LogCategory) {
    LogCategory["USER"] = "USER";
    LogCategory["AUTH"] = "AUTH";
    LogCategory["API"] = "API";
    LogCategory["PERF"] = "PERF";
    LogCategory["ERROR"] = "ERROR";
    LogCategory["SYSTEM"] = "SYSTEM";
})(LogCategory || (LogCategory = {}));
//# sourceMappingURL=types.js.map